import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getLiveUrl } from "@/lib/urlHelpers";
import ProfileHeaderAvatar from "@/components/ProfileHeaderAvatar";
import ProfileHeaderBackground from "@/components/ProfileHeaderBackground";

interface Props {
  user: UserPublicData;
}

export default Vue.extend({
  functional: true,
  name: "ProfileHeader",
  props: {
    user: { required: true },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { user } = ctx.props;
    const background = user.background ? MediaFilesController.getImageThumbnail(user.background.urlPart, "1080p") : "";
    const avatar = h(ProfileHeaderAvatar, { props: { user, animate: true } });
    return h(
      "div",
      {
        ...ctx.data,
        class: "profile-header",
        style: [
          { position: "relative" },
          ...(Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style]),
          ctx.data.staticStyle,
        ],
      },
      [
        h(ProfileHeaderBackground, { props: { background } }),
        h("div", { class: "d-flex __wrap" }, [
          !!user.publicLivechatUser
            ? h("router-link", { class: "mx-auto", props: { to: getLiveUrl(user) } }, [avatar])
            : avatar,
        ]),
        ctx.scopedSlots.default && ctx.scopedSlots.default({}),
      ]
    );
  },
});
